import {ShopOrderQueryParams} from './remit-shop.service';

export type SevenElevenExportFilters = Omit<ShopOrderQueryParams,
  'pageNumber' | 'pageSize' | 'isDeleted'> & {
  isDeletedOrExpired?: 'Y' | 'N';
  OrderStatusesExcluded?: string[];
};

export type SevenElevenExportRequest =
  | {scope: 'filtered'; filters: SevenElevenExportFilters}
  | {scope: 'selected'; orderIds: string[]};

export interface SevenElevenExportRow {
  orderId: string;
  receiverName: string;
  receiverPhone: string;
  pickupStoreCode: string;
  temperature: string;
  productName: string;
  orderAmount: number;
  shippingAmount: number;
  canShipAt: string | null;
}

export interface SevenElevenExportError {
  orderId: string;
  field: string;
  code: string;
  message: string;
}

export interface SevenElevenExportPreview {
  matchedCount: number;
  validCount: number;
  invalidCount: number;
  rows: SevenElevenExportRow[];
  errors: SevenElevenExportError[];
}

// Keep the list's values/date boundaries intact, omitting only pagination and
// unused values. Unknown active fields reach the backend for explicit rejection.
export function sevenElevenExportFilters(
    values: SevenElevenExportFilters & {
      pageNumber?: number | null; pageSize?: number | null;
    },
): SevenElevenExportFilters {
  return Object.fromEntries(Object.entries(values).filter(([key, value]) =>
    key !== 'pageNumber' && key !== 'pageSize' &&
    value !== null && value !== undefined && value !== '' &&
    !(Array.isArray(value) && value.length === 0),
  ));
}
